module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/assets/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.eot
// module chunks = styles